import React, { useState, useEffect } from 'react'
import { Alert, Button } from 'reactstrap'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLifeRing } from '@fortawesome/free-solid-svg-icons'
import { message } from 'antd'

import ListTopBar from '../../components/ListTopBar'

import InvoicesTable from './partials/InvoicesTable'
import NewTicketModal from '../Tickets/partials/NewTicketModal'

import { getInvoices } from './services'
import { getUri } from '../../services/springCenfApi'
import { storeDownloadToken } from '../DownloadTokens/services'
import { handleError, parsePagination } from '../../helpers'

export default function InvoicesList() {
	const user = useSelector(state => state.auth.user)
	const [invoices, setInvoices] = useState(null)
	const [filterType, setFilterType] = useState('consecutive')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [showTicketsModal, setShowTicketsModal] = useState(false)
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		!invoices && getInvoices({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			'filter[supplier_id]': user.id,
			include: 'certificates',
			sort: '-admitted_at'
		})
			.then(res => {
				setInvoices(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ invoices, pagination, filterType, filterValue, filterScope, user ])

	const handleExport = () => {
		setLoading(true)
		let token = new Date().getTime()
		storeDownloadToken({ type: `Descarga de Facturas`, token, supplier_id: user.id })
			.then(() => {
				message.info('Generando reporte en nueva pestaña')
				window.open(`${getUri()}/reports/export/invoices/${user.id}/${token}`)
			})
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<React.Fragment>
			<ListTopBar 
				title="Facturas Radicadas"
				subtitle="Listado de facturas radicadas en Spring"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				reload={() => setInvoices(null)}
				options={[
					{ label: 'Buscar por consecutivo', value: 'consecutive' },
					{ label: 'Buscar por concepto', value: 'description' },
					{ label: 'Buscar fecha admisión (YYYY-MM-DD)', value: 'admitted_at' },
				]}
				scopes={[
					{ label: 'Pendientes de pago', value: 'pendding' },
					{ label: 'Facturas pagadas', value: 'paid' },
					{ label: 'Rechazadas por novedad', value: 'rejected' },
				]}
				onExport={handleExport}
				disabledExport={loading}
			/>
			<div className='inline-block full-width'>
				<Alert className='p-5 mt-0 mb-10' color='warning'>Solo podrá ver facturas admitidas por el departamento a cargo. No se muestran facturas emitidas a la Dian que no esten admitidas internamente.</Alert>
			</div>
			<InvoicesTable 
				invoices={invoices}
				reload={() => setInvoices(null)}
				pagination={pagination}
				setPagination={setPagination}
			/>			
			<Button color='warning' size="sm" onClick={() => setShowTicketsModal(true)}>
				<FontAwesomeIcon icon={faLifeRing} className='mr-5' />
			   No veo la factura que busco
			</Button>
			{ showTicketsModal && (
				<NewTicketModal 
					visible
					onClose={() => setShowTicketsModal(false)}
					scope="invoices"
				/>
			)}
		</React.Fragment>
	)
}